module.exports = __webpack_public_path__ + "static/media/playIcon.d49c84e4.svg";